import React, { FC, PropsWithChildren } from 'react';
import { Box, Grid } from '@lifechurch/react-ion';
import { useTranslation } from 'react-i18next';

const HeaderItem: FC<PropsWithChildren> = ({ children }) => <Box fontWeight={2}>{children}</Box>;

const TableHeader: FC = () => {
  const { t } = useTranslation('moments');
  return (
    <Grid
      fontSize={2}
      gridColumnGap='1rem'
      gridTemplateColumns='100px 1fr 85px 165px'
      marginBlockEnd={3}
      px={5}
    >
      <Box />
      <HeaderItem>{t('content')}</HeaderItem>
      <HeaderItem>{t('last_edit')}</HeaderItem>
      <Box />
    </Grid>
  );
};

const NextStepsTableHeader: FC = () => {
  const { t } = useTranslation('moments');
  return (
    <Grid
      fontSize={2}
      gridColumnGap='1rem'
      gridTemplateColumns='32px 160px 2fr 1fr'
      marginBlockEnd={3}
      px={5}
    >
      <HeaderItem>{t('icon')}</HeaderItem>
      <HeaderItem>{t('title')}</HeaderItem>
      <HeaderItem>{t('description')}</HeaderItem>
      <HeaderItem>{t('url')}</HeaderItem>
      <Box />
    </Grid>
  );
};

export { TableHeader, NextStepsTableHeader };
